/* CSS */

import "./index.css";

/* Custom scripts */

// import './js/animxyz';
// import './js/aspect-ratios';
// import './js/counterup';
// import './js/inner-height-calc';
// import './js/lightbox';
import "./js/navigation";
import "./js/remove-empty-paragraph";
// import './js/same-height';
import "./js/set-body-height";
import "./js/toggle-outline";

function setupKunskapsartikelTableOfContentsObserver(headingLinkPairs) {
  if (!headingLinkPairs.length) {
    return;
  }

  if (!("IntersectionObserver" in window)) {
    return;
  }

  function updateActiveLinksByPosition() {
    const viewportMiddle = window.innerHeight / 2;

    headingLinkPairs.forEach((pair) => {
      const rect = pair.heading.getBoundingClientRect();
      const isAboveViewport = rect.top < 0;
      const isInTopHalfOfViewport = rect.bottom > 0 && rect.top < viewportMiddle;

      if (isAboveViewport || isInTopHalfOfViewport) {
        pair.link.classList.add("kunskapsartikel-table-of-contents-link-active");
      } else {
        pair.link.classList.remove(
          "kunskapsartikel-table-of-contents-link-active"
        );
      }
    });
  }

  const observer = new IntersectionObserver(
    () => {
      updateActiveLinksByPosition();
    },
    {
      root: null,
      threshold: 0,
    }
  );

  headingLinkPairs.forEach((pair) => {
    observer.observe(pair.heading);
  });

  updateActiveLinksByPosition();
  window.addEventListener("scroll", updateActiveLinksByPosition, {
    passive: true,
  });
  window.addEventListener("resize", updateActiveLinksByPosition);
  window.addEventListener("hashchange", updateActiveLinksByPosition);
}

function buildKunskapsartikelTableOfContents() {
  const tableOfContentsContainer = document.querySelector(
    "#kunskapsartikel-table-of-contents"
  );
  const contentContainer = document.querySelector("#kunskapsartikel-content");

  // Kolla om vi är på rätt sida.
  if (!tableOfContentsContainer) {
    return;
  }
  if (!contentContainer) {
    return;
  }

  const headings = contentContainer.querySelectorAll("h2, h3");

  if (!headings.length) {
    tableOfContentsContainer.classList.add("hidden");
    return;
  }

  tableOfContentsContainer.innerHTML = "";
  const slugCount = {};
  const headingLinkPairs = [];

  function createSlug(text) {
    const baseSlug = text
      .toLowerCase()
      .trim()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-")
      .replace(/^-|-$/g, "");

    let safeBaseSlug = baseSlug;

    if (!safeBaseSlug) {
      safeBaseSlug = "section";
    }

    if (!slugCount[safeBaseSlug]) {
      slugCount[safeBaseSlug] = 1;
      return safeBaseSlug;
    }

    slugCount[safeBaseSlug] += 1;
    return `${safeBaseSlug}-${slugCount[safeBaseSlug]}`;
  }

  headings.forEach((heading) => {
    let text = "";

    if (heading.textContent) {
      text = heading.textContent.trim();
    }

    if (!text) {
      return;
    }

    if (!heading.id) {
      heading.id = createSlug(text);
    }

    const link = document.createElement("a");
    link.href = `#${heading.id}`;
    link.textContent = text;
    link.classList.add("kunskapsartikel-table-of-contents-link");

    tableOfContentsContainer.appendChild(link);
    headingLinkPairs.push({ heading, link });
  });

  setupKunskapsartikelTableOfContentsObserver(headingLinkPairs);
}

if (document.readyState === "loading") {
  document.addEventListener(
    "DOMContentLoaded",
    buildKunskapsartikelTableOfContents
  );
} else {
  buildKunskapsartikelTableOfContents();
}

/*

GSAP

*/

import { gsap } from "gsap";

/* The following plugin is a Club GSAP perk */
import { MorphSVGPlugin } from "gsap/MorphSVGPlugin";

// import './js/woocommerce';

// eslint-disable-next-line import/no-extraneous-dependencies
// import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { Observer } from "gsap/Observer";

// gsap.registerPlugin(ScrollTrigger, Observer);

// const revealContainers = document.querySelectorAll(".reveal-container");

// revealContainers.forEach((container) => {
// 	const image = container.querySelector("img");
// 	const tl = gsap.timeline({
// 		scrollTrigger: {
// 			trigger: container,
// 			toggleActions: "restart none none reset",
// 		},
// 	});

// 	tl.set(container, { autoAlpha: 1 });
// 	tl.from(container, 1.5, {
// 		xPercent: -100,
// 		ease: Power2.out,
// 	});
// 	tl.from(image, 1.5, {
// 		xPercent: 100,
// 		scale: 1.3,
// 		delay: -1.5,
// 		ease: Power2.out,
// 	});
// });

/* Swiper */

// import Swiper from "swiper";
// import "swiper/css";
// import "swiper/css/navigation";
// import "swiper/css/pagination";

// import "swiper/swiper-bundle.css";

// import './js/swiper/swiper-overflow-slider';
// import './js/swiper/swiper-testimonials-slider';
// import './js/swiper/swiper-fullscreen-slider';

/* Spotlight */

// import spotlight, { prev } from 'spotlight.js';

/* chartjs */

// import Chart from 'chart.js/auto';

const readMoreLinks = document.querySelectorAll(".medarbetare-read-more-link");

readMoreLinks.forEach((link) => {
  link.addEventListener("click", function (event) {
    event.preventDefault();

    const card = this.closest(".medarbetare-card");

    if (card.classList.contains("medarbetare-card-active")) {
      card.classList.remove("medarbetare-card-active");
      return;
    }

    document
      .querySelectorAll(".medarbetare-card.medarbetare-card-active")
      .forEach((activeCard) => {
        activeCard.classList.remove("medarbetare-card-active");
      });

    card.classList.add("medarbetare-card-active");
  });
});

const closeButtons = document.querySelectorAll(
  ".medarbetare-card-close-button"
);

closeButtons.forEach((button) => {
  button.addEventListener("click", function () {
    const card = this.closest(".medarbetare-card");

    card.classList.remove("medarbetare-card-active");
  });
});

const backgrounds = document.querySelectorAll(
  ".medarbetare-read-more-card-background"
);

backgrounds.forEach((background) => {
  background.addEventListener("click", function (event) {
    if (event.target === event.currentTarget) {
      const card = this.closest(".medarbetare-card");

      card.classList.remove("medarbetare-card-active");
    }
  });
});

// Hanterar tabbarna på kategori-sidorna.

const checkTabs = document.querySelectorAll(".category-tab");

if (checkTabs.length > 0) {
  const deactivateAllTabsAndButtons = () => {
    document
      .querySelectorAll(".category-tab, .category-tab-button")
      .forEach((el) => {
        el.classList.remove(
          "category-tab-active",
          "category-tab-button-active"
        );
      });
  };

  const activateTabAndButton = (index) => {
    document
      .querySelector(`.category-tab[data-tab-index="${index}"]`)
      .classList.add("category-tab-active");
    document
      .querySelector(`.category-tab-button[data-tab-index="${index}"]`)
      .classList.add("category-tab-button-active");
  };

  document.querySelectorAll(".category-tab-button").forEach((button) => {
    button.addEventListener("click", () => {
      deactivateAllTabsAndButtons();
      activateTabAndButton(button.dataset.tabIndex);
    });
  });

  activateTabAndButton("1");
}

/*

Döljer category images på kategorisidor som inte har produkter.

*/

// const checkWCPT = document.querySelector(".wcpt");

// if (checkWCPT) {
// 	const categoryDetailsContainer = document.querySelector(
// 		".matane-category-details-container"
// 	);
// 	categoryDetailsContainer.classList.remove("hidden");
// }

// if (checkWCPT) {
// 	// Here we iterat through each table by its class
// 	document.querySelectorAll(".wcpt-table").forEach((table) => {
// 		const emptyColumns = new Set(); // Stores the indexes of empty columns

// 		// Check each cell in the table body to find empty columns
// 		table.querySelectorAll("tbody tr").forEach((row) => {
// 			row.querySelectorAll("td").forEach((cell, index) => {
// 				if (cell.innerText.trim() === "") {
// 					emptyColumns.add(index); // Add empty column index
// 				}
// 			});
// 		});

// 		// Hides header and cells of empty columns
// 		emptyColumns.forEach((index) => {
// 			// Döljer headings
// 			table.querySelectorAll("th").forEach((header, headerIndex) => {
// 				if (headerIndex === index) {
// 					header.style.display = "none";
// 				}
// 			});

// 			// Döljer tomma celler
// 			table.querySelectorAll("tr").forEach((row) => {
// 				row.querySelectorAll("td").forEach((cell, cellIndex) => {
// 					if (cellIndex === index) {
// 						cell.style.display = "none";
// 					}
// 				});
// 			});
// 		});
// 	});
// }

// const checkWCPT = document.querySelector(".wcpt");
// const checkProductArchivePage = document.querySelector(
// 	".product-category.product"
// );

// if (checkWCPT) {
// 	console.log("Check WCPT: OK");

// 	if (!checkProductArchivePage) {
// 		console.log("This page shows: Products");
// 		const categoryDetailsContainer = document.querySelector(
// 			".matane-category-details-container"
// 		);
// 		categoryDetailsContainer.classList.remove("hidden");
// 	} else {
// 		console.log("This page shows: Categories");
// 	}

// 	if (!checkProductArchivePage) {
// 		document.querySelectorAll(".wcpt-table").forEach((table) => {
// 			const emptyColumns = new Set();

// 			table.querySelectorAll("tbody tr").forEach((row) => {
// 				row.querySelectorAll("td").forEach((cell, index) => {
// 					if (cell.innerText.trim() === "") {
// 						emptyColumns.add(index); // Add empty column index
// 					}
// 				});
// 			});

// 			// Hides header and cells of empty columns
// 			emptyColumns.forEach((index) => {
// 				// Döljer headings
// 				table.querySelectorAll("th").forEach((header, headerIndex) => {
// 					if (headerIndex === index) {
// 						header.style.display = "none";
// 					}
// 				});

// 				// Döljer tomma celler
// 				table.querySelectorAll("tr").forEach((row) => {
// 					row.querySelectorAll("td").forEach((cell, cellIndex) => {
// 						if (cellIndex === index) {
// 							cell.style.display = "none";
// 						}
// 					});
// 				});
// 			});
// 		});
// 	}
// }
document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    const woocommerceProductArchivePage = document.querySelector(
      ".woocommerce.archive"
    );
    const checkWCPT = document.querySelector(".wcpt");
    const WCPTinner = document.querySelector(
      ".wcpt-table-scroll-wrapper-outer"
    );
    const checkProductArchivePage = document.querySelector(
      ".product-category.product"
    );

    try {
      if (woocommerceProductArchivePage) {
        if (!checkProductArchivePage) {
          console.log("Denna sida visar: Produkter");
          try {
            if (checkWCPT) {
              WCPTinner.style.opacity = "1";
              checkWCPT.classList.add("matane-hide-loader");
              console.log("Ändrade opacitet för .wcpt till 1.");
            }
            const categoryDetailsContainer = document.querySelector(
              ".matane-category-details-container"
            );
            categoryDetailsContainer.classList.remove("hidden");
            const parentCategoryTextTopContainer = document.querySelector(
              ".matane-parent-category-text-top-container"
            );
            parentCategoryTextTopContainer.classList.add("hidden");
            const parentCategoryTextBottomContainer = document.querySelector(
              ".matane-parent-category-text-bottom-container"
            );
            parentCategoryTextBottomContainer.classList.add("hidden");

            console.log("Tog bort 'hidden' från kategoridetaljer-container.");
          } catch (error) {
            console.error(
              "Något fel vid åtkomst eller ändring av kategoridetaljer container:",
              error
            );
          }
        } else {
          console.log("Denna sida visar: Kategorier");
        }

        if (!checkProductArchivePage) {
          document.querySelectorAll(".wcpt-table").forEach((table) => {
            console.log("Kör tabell: ", table);
            const emptyColumns = new Set();

            table.querySelectorAll("tbody tr").forEach((row) => {
              row.querySelectorAll("td").forEach((cell, index) => {
                if (cell.innerText.trim() === "") {
                  emptyColumns.add(index);
                }
              });
            });

            console.log("Tomma kolumn index är: ", Array.from(emptyColumns));

            emptyColumns.forEach((index) => {
              table.querySelectorAll("th").forEach((header, headerIndex) => {
                if (headerIndex === index) {
                  header.style.display = "none";
                  console.log(
                    `Dolde header vid index ${index}:`,
                    header.innerHTML
                  );
                }
              });

              table.querySelectorAll("tr").forEach((row) => {
                row.querySelectorAll("td").forEach((cell, cellIndex) => {
                  if (cellIndex === index) {
                    cell.style.display = "none";
                    console.log(`Dolde cell vid index ${index} i rad ${row}`);
                  }
                });
              });
            });
          });
        }
      }
    } catch (error) {
      console.error("Ett fel hände:", error);
    }
  }, 1000);
});

/*

Lightbox

*/

if (document.querySelector(".lightbox-button")) {
  const lightboxButtons = document.querySelectorAll(".lightbox-button");
  const staticLightboxContentElement = document.querySelector(
    ".static-lightbox-content"
  );
  const staticLightbox = document.querySelector(".static-lightbox");
  const staticLightboxBackground = document.querySelector(
    ".static-lightbox-background"
  );
  const staticLightboxContent = document.querySelector(
    ".static-lightbox-content"
  );

  lightboxButtons.forEach((lightboxButton) => {
    lightboxButton.addEventListener("click", (e) => {
      e.preventDefault();
      lightboxButton.classList.toggle("active");
      const currentLightboxElement = document.querySelector(
        ".lightbox-button.active + .lightbox-content"
      );
      const lightboxContent = currentLightboxElement.innerHTML;
      staticLightboxContentElement.innerHTML = lightboxContent;
      if (staticLightbox.classList.contains("hidden")) {
        staticLightbox.classList.remove("hidden");
        staticLightbox.classList.add("flex");
      }
    });
  });

  staticLightboxBackground.addEventListener("click", (e) => {
    if (e.target.classList.contains("static-lightbox-background")) {
      if (staticLightbox.classList.contains("flex")) {
        staticLightbox.classList.remove("flex");
        staticLightbox.classList.add("hidden");

        lightboxButtons.forEach((lightboxButton) => {
          if (lightboxButton.classList.contains("active")) {
            lightboxButton.classList.remove("active");
          }
        });

        staticLightboxContent.innerHTML = "";
      }
    }
  });
}

gsap.registerPlugin(MorphSVGPlugin);

const tl = gsap.timeline({
  repeat: 2,
  yoyo: true,
  repeatDelay: 0.1,
});

tl.to(".f2", { duration: 2, morphSVG: ".f1", ease: "power2.easeInOut" });

const tl2 = gsap.timeline({
  repeat: 2,
  yoyo: true,
  repeatDelay: 0.1,
});

tl2.to(".b2", { duration: 2, morphSVG: ".b1", ease: "power2.easeInOut" });
